export default __webpack_public_path__ + "static/media/hero.97a1400b.jpg";